import React from 'react';
import { Field, getFormValues } from 'redux-form';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { Select, SelectItem } from '@topconagriculture/react-components';
import { usePermissions } from '@topconagriculture/casbin-react';
import { Action, Resource } from '@topconagriculture/permissions';
import { useModal } from '@topconagriculture/modal';

import {
  getIngredientsInRecipeListAreValidAtLeastOne,
  getPreviewRecipe,
  getTransitionDays,
} from '../../../../../../store/application/recipes/appRecipes.selector';
import { ModalsNames } from '../../../../../../config/modals/modalNames';
import { RecipeType } from '../../../../../../store/entities/recipes/recipes.types';
import { recipeTypeItems } from '../../../../../../config/constants';
import { Forms } from '../../../../../../store/form/form.selector';

export enum RecipeTransitions {
  NONE = 'none',
  DAYS_ON_RATION = 'daysOnRation',
  FIXED_DATES = 'fixedDates',
}

const RecipeTransitionField = () => {
  const { t } = useTranslation();

  const { dispatchOpenModal } = useModal();

  const transitionDays = useSelector(getTransitionDays);
  const recipePreview = useSelector(getPreviewRecipe);
  const ingredientsHasWeight = useSelector(getIngredientsInRecipeListAreValidAtLeastOne);
  const formValues = useSelector(getFormValues(Forms.recipeForm)) as any;

  const recipeType = formValues?.recipeType;

  const transitionAllowed = recipePreview ? recipePreview.transitionAllowed : true;

  const isRefusalOrAddToBaseRecipe =
    recipeType === recipeTypeItems[RecipeType.AddToBaseRecipe].id ||
    recipeType === recipeTypeItems[RecipeType.RefusalSubstitute].id;

  const { hasPermission: hasDaysOnRationPermission } = usePermissions({
    action: Action.USE,
    resource: Resource.FEED_RATION_TRANSITION,
  });

  const { hasPermission: hasRationTransitionFixednPermission } = usePermissions({
    action: Action.USE,
    resource: Resource.FEED_RATION_TRANSITION_FIXED,
  });

  const onSelectFixedDateTransition = () => {
    dispatchOpenModal({
      modalName: ModalsNames.recipeFixedDateTransitionModal,
    });
  };

  const recipeTransitionOptions = [
    <SelectItem key={RecipeTransitions.NONE} value={RecipeTransitions.NONE}>
      {t('mixers:none')}
    </SelectItem>,
    !isRefusalOrAddToBaseRecipe && transitionAllowed && hasDaysOnRationPermission && (
      <SelectItem key={RecipeTransitions.DAYS_ON_RATION} value={RecipeTransitions.DAYS_ON_RATION}>
        {t('feeds:days_on_ration')}
      </SelectItem>
    ),
    !isRefusalOrAddToBaseRecipe && transitionAllowed && hasRationTransitionFixednPermission && (
      <SelectItem
        key={RecipeTransitions.FIXED_DATES}
        value={RecipeTransitions.FIXED_DATES}
        onClick={onSelectFixedDateTransition}
      >
        {t('products:fixed_dates')}
      </SelectItem>
    ),
  ];

  if (recipeTransitionOptions.length === 0) {
    return null;
  }

  return (
    <div>
      <Field
        name="recipeTransition"
        placeholder={t('products:select_type')}
        label={t('products:recipe_transitions')}
        component={Select}
        defaultValue={RecipeTransitions.NONE}
        disabled={!ingredientsHasWeight || transitionDays.length > 1}
      >
        {recipeTransitionOptions}
      </Field>
    </div>
  );
};

export default RecipeTransitionField;
